import {
  GET_ALL_ACCA7,
  GET_ALL_ACCA7_RESPONSE_SUCCESS,
  CREATE_ACCA7,
  UPDATE_ACCA7,
  DELETE_ACCA7,
} from "./actionTypes"

export const getAllAcca7 = () => {
  return {
    type: GET_ALL_ACCA7,
  }
}
export const getAllAcca7ResponseSuccess = payload => ({
  type: GET_ALL_ACCA7_RESPONSE_SUCCESS,
  payload: payload,
})

// ------------------------------------- CREATE --------------------------------------------------------

export const createAcca7 = (payload, history) => {
  return {
    type: CREATE_ACCA7,
    payload: payload,
    history,
  }
}

// ------------------------------------- EDIT --------------------------------------------------------

export const updateAcca7 = (payload, history, redirectTo) => {
  return {
    type: UPDATE_ACCA7,
    payload: payload,
    history,
    redirectTo,
  }
}

// ------------------------------------- DELETE --------------------------------------------------------

export const deleteAcca7 = payload => ({
  type: DELETE_ACCA7,
  payload: payload,
})
